define('WebReviews.Reviews', [
    'WebReviews.Rating.View',
    'webreviews_center.tpl',
    'Backbone',
    'underscore'
], function WebReviewsReviews(
    WebReviewsRatingView,
    webReviewsCenterTpl,
    Backbone,
    _
) {
    'use strict';

    return Backbone.View.extend({
        contextDataRequest: ['item'],
        template: webReviewsCenterTpl,
        getItem: function getItem() {
            return this.contextData.item();
        },
        initialize: function initialize(options) {
            this.fields = (options.config && options.config.fields) ? options.config.fields : null;
        },
        getReviews: function getReviews() {
            var fields = this.fields;
            var item = this.getItem();
            var reviews = [];

            if (fields && fields.length) {
                _.each(fields, function each(field) {
                    if (field.abbreviation && field.score) {
                        reviews.push({
                            webReviewReviewer: item[field.reviewer],
                            webReviewAbbreviation: item[field.abbreviation],
                            webReviewScore: item[field.score],
                            webReviewText: item[field.text]
                        });
                    }
                });

                reviews = _.reject(reviews, function reject(review) {
                    return (!review.webReviewReviewer && !review.webReviewAbbreviation && !review.webReviewScore && !review.webReviewText);
                });
            }

            return reviews;
        },
        childViews: {
            'WebReviews.Rating': function webReviewsChildView() {
                return new WebReviewsRatingView({
                    pdp: this.options.pdp,
                    application: this.options.application
                });
            }
        },
        getContext: function getContext() {
            var showReviews;
            var reviews = this.getReviews();

            showReviews = !!(reviews.length);

            return {
                reviews: reviews,
                showReviews: showReviews
            };
        }
    });
});
